/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dry_Known_Samuel_DanceInputs */

const fr_dry_known_samuel_dance = /** @type {(inputs: Dry_Known_Samuel_DanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produit`)
};

/**

* @param {Dry_Known_Samuel_DanceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dry_known_samuel_dance = /** @type {((inputs?: Dry_Known_Samuel_DanceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Known_Samuel_DanceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dry_known_samuel_dance(inputs)
});